import { useState } from 'react'

import { Combobox } from '@headlessui/react'
import { clsx } from 'clsx'
import { useNavigate } from 'react-router-dom'

import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useI18n } from '../../../i18n/index.js'
import { ActionItem } from '../../CommandBar.types.js'
import { useCommandBar } from '../../CommandBarContext.js'
import { useQueryCommands } from '../../hooks/index.js'

import { CommandsSection } from './CommandsSection.js'

export const CommandResults = () => {
  const { $t } = useI18n()
  const [query, setQuery] = useState('')

  const { actionsByCategory } = useQueryCommands(query)

  const items = Object.keys(actionsByCategory)
  const { close } = useCommandBar()
  const navigate = useNavigate()

  const runAction = (actionItem: ActionItem) => {
    close()

    if (typeof actionItem?.action === 'function') {
      actionItem.action()
      return
    }

    navigate(actionItem?.url)
  }

  return (
    <Combobox
      onChange={runAction}
      as="div"
      className="divide-y divide-line-subdued"
    >
      <div className="flex flex-1 py-3 gap-2 px-4 lg:px-5 items-center">
        <SvgIcon name="search" size="lg" className="text-content-disabled" />

        <Combobox.Input
          displayValue={() => query} // this value is passed to avoid empty input when clicked outside of the combobox area
          className="border-none outline-none text-heading-2xs flex-1 py-1 bg-surface"
          placeholder={$t({
            id: 'Generic.SearchDotDotDot',
            defaultMessage: 'Search...',
          })}
          value={query}
          onChange={event => setQuery(event.target.value)}
          autoFocus
          maxLength={200}
        />

        <IconButton
          tabIndex={-1}
          variant="plainNeutral"
          rounded
          size="xs"
          icon={<SvgIcon name="close" size="sm" className="text-surface" />}
          onClick={() => setQuery('')}
          className={clsx(
            '!bg-background-divider',
            query ? 'opacity-100' : 'opacity-0',
          )}
        />
      </div>
      <div className="flex flex-col flex-1 overflow-hidden divide-y divide-line-subdued min-h-screen sm:min-h-0 sm:max-h-[80dvh] overflow-y-auto">
        {items?.map(category => (
          <CommandsSection
            key={category}
            category={category}
            actions={actionsByCategory[category]}
            className="first:pt-0"
          />
        ))}
      </div>
    </Combobox>
  )
}
